export const formatDate = (date: Date | string | null | undefined): string => {
  if (!date) return '-';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  // Verificar si la fecha es válida
  if (isNaN(dateObj.getTime())) return '-';
  return dateObj.toLocaleDateString();
};

export const formatDateTime = (date: Date | string, options?: Intl.DateTimeFormatOptions): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const defaultOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };
  return dateObj.toLocaleString('es-ES', { ...defaultOptions, ...options });
};

export const formatDateWithTime = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };
  return dateObj.toLocaleString('es-ES', options);
};

/** Mismo formato visual que fecha en cabeceras (ej. «08 oct 2025») sin hora. */
export const formatDateShortMonthEs = (date: Date | string | null | undefined): string => {
  if (!date) return '-';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(dateObj.getTime())) return '-';
  return dateObj.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const truncate = (str: string, length: number): string => {
  return str.length > length ? str.slice(0, length) + '...' : str;
};

export const formatBoolean = (value: boolean, trueText = 'Sí', falseText = 'No'): string => {
  return value ? trueText : falseText;
};
